import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import avo from 'analytics/avo';
import useIsBrowser from 'hooks/useIsBrowser';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useProductAR from 'data-hooks/useProductAR';
import useProductAttributes from 'data-hooks/useProductAttributes';

// AR Quick Look on iOS/iPadOS Safari; Cylindo's QR flow everywhere else
const supportsARQuickLook = () => {
  const anchor = document.createElement('a');
  return !!anchor.relList?.supports?.('ar');
};
const trackARClick = url => {
  avo.ctaClicked({
    text: 'AR Mode',
    targetUrl: url,
    /* eslint no-underscore-dangle: 0 */
    cta: avo.Cta._3D_VIEWER,
    location: avo.Location.PDP,
    component: avo.Component.PRODUCT_CARD
  });
};

// AR pill for the controls bar; Quick Look URL matches PDPView3DButton
const PDPGalleryRevampARButton = t0 => {
  const $ = _c(27);
  const {
    className,
    showDivider: t1,
    onLaunchViewerAR: t2
  } = t0;
  const showDivider = t1 === undefined ? false : t1;
  const onLaunchViewerAR = t2 === undefined ? null : t2;
  const {
    loading,
    data: t3
  } = usePDPBasicDetails();
  let t4;
  if ($[0] !== t3) {
    t4 = t3 === undefined ? {} : t3;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const basicDetailsData = t4;
  const {
    name: productName,
    custom_properties: t5
  } = basicDetailsData;
  let t6;
  if ($[2] !== t5) {
    t6 = t5 === undefined ? {} : t5;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const customProperties = t6;
  const arAsset = customProperties.ar_asset;
  const arAssetUpholstery = customProperties.ar_asset_upholstery;
  const {
    data: t7
  } = useProductAR();
  const {
    arPrice
  } = t7;
  const {
    data: attributesData
  } = useProductAttributes();
  const isBrowser = useIsBrowser();
  if (loading || !isBrowser) {
    return null;
  }
  const useQuickLook = !!arAsset && supportsARQuickLook();
  if (!useQuickLook && !onLaunchViewerAR) {
    return null;
  }
  let t8;
  if ($[4] !== showDivider) {
    t8 = showDivider && <div className="h-[45px] w-px bg-gray-light6" />;
    $[4] = showDivider;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const divider = t8;
  if (!useQuickLook) {
    let t9;
    if ($[6] !== onLaunchViewerAR) {
      t9 = () => {
        trackARClick(null);
        onLaunchViewerAR();
      };
      $[6] = onLaunchViewerAR;
      $[7] = t9;
    } else {
      t9 = $[7];
    }
    let t10;
    if ($[8] !== className || $[9] !== t9) {
      t10 = <button type="button" className={className} onClick={t9}>AR Mode</button>;
      $[8] = className;
      $[9] = t9;
      $[10] = t10;
    } else {
      t10 = $[10];
    }
    let t11;
    if ($[11] !== divider || $[12] !== t10) {
      t11 = <>{divider}{t10}</>;
      $[11] = divider;
      $[12] = t10;
      $[13] = t11;
    } else {
      t11 = $[13];
    }
    return t11;
  }
  const t9 = `#callToAction=Close&checkoutTitle=${encodeURIComponent(productName || "")}`;
  let t10;
  if ($[14] !== arAssetUpholstery || $[15] !== arPrice || $[16] !== t9) {
    t10 = t9.concat(arAssetUpholstery ? `&checkoutSubtitle=${encodeURIComponent(`Shown in ${arAssetUpholstery}`)}` : "", `&price=$${arPrice}`);
    $[14] = arAssetUpholstery;
    $[15] = arPrice;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const banner = t10;
  const canonicalURL = attributesData?.SEOAttributes?.canonicalURL;
  const canonicalParam = canonicalURL ? `&canonicalWebPageURL=${encodeURIComponent(canonicalURL)}` : "";
  const url = `${arAsset}${banner}${canonicalParam}&allowsContentScaling=0`;
  let t11;
  if ($[18] !== url) {
    t11 = () => trackARClick(url);
    $[18] = url;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== className || $[21] !== t11 || $[22] !== url) {
    t12 = <a className={className} href={url} onClick={t11}>AR Mode</a>;
    $[20] = className;
    $[21] = t11;
    $[22] = url;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== divider || $[25] !== t12) {
    t13 = <>{divider}{t12}</>;
    $[24] = divider;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
};
PDPGalleryRevampARButton.propTypes = {
  className: PropTypes.string,
  showDivider: PropTypes.bool,
  onLaunchViewerAR: PropTypes.func
};
export default PDPGalleryRevampARButton;